import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  styled,
  TextField,
  Paper,
  Grid,
  Box,
  Fab,
  MenuItem,
  Snackbar,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Modal,
  Button,
} from "@mui/material";
import AdapterDayjs from "@mui/lab/AdapterDayjs";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import MuiAlert from "@mui/material/Alert";

import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import { serverTimestamp } from "firebase/firestore";

import { SaveCloseDialog } from "../components/SaveCloseDialog";
import { Save, Close } from "@mui/icons-material";
import { useFetchCollectionDocs } from "apis/dataSnapshots";
import { Context } from "context/Wrapper";
import { doc, getDoc, or, setDoc, where, query, collection, getDocs, arrayUnion, arrayRemove, updateDoc, writeBatch, addDoc } from "firebase/firestore";
import { db } from "config/config";
import InfiniteScrollSelect from "components/shared/InfiniteScrollSelect";
import { CreateUniqueDocument } from "components/shared/createUniqueDocument ";
import ClearIcon from '@mui/icons-material/Clear';
import { useSubscriptionState } from "context/SubscriptionContext";
import { useFetchUserDefinedOptions } from "components/fetchUserDefinedOptions";
import { v4 as uuidv4 } from "uuid";



const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Item = styled(Paper)(({ theme }) => {
  return {
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.primary.main,
    background: theme.palette.secondary.main,
  };
});

export const ProjectNew = (props) => {
  const { projectId } = useParams();

  const context = useContext(Context);

  const currentSubscription = useSubscriptionState()

  const [groupUsers, setGroupUsers] = useState([]);

  const location = useLocation()

  const [openModal, setOpenModal] = useState(false);

  const { groupId, isPro, userId } = context?.state?.userProfile || {};
  const userProfile = context?.state?.userProfile || {},
    { showAllDataFlag } = context?.state || {};

  const contacts = useFetchCollectionDocs({
    collectionName: "contacts",
    conditions:
      userId && groupId && isPro && showAllDataFlag
        ? [or(where("groupId", "==", groupId), where("userId", "==", userId))]
        : userId
          ? [where("userId", "==", userId)]
          : [],
    setContext: context.setState,
  });

  const buildings = useFetchCollectionDocs({
    collectionName: "buildings",
    conditions:
      groupId && isPro && showAllDataFlag
        ? [
          or(
            where("groupId", "==", userProfile?.groupId),
            where("userId", "==", userProfile.userId),
          ),
        ]
        : [where("userId", "==", userProfile.userId)],
  });

  const navigate = useNavigate();

  const [projectDetail, setProjectDetail] = useState(location?.state?.fromBuildingReferencesJobDetails?.fromBuildingReferencesJob ?
    { building: location?.state?.fromBuildingReferencesJobDetails?.buildingId } : {});

  const [projectBuildingDetails, setProjectBuildingDetails] = useState()


  const [tab, setTab] = React.useState(0);
  const [duplicateOpen, setduplicateOpen] = React.useState(false);
  const [SubmitLoader, setSubmitLoader] = React.useState(false);

  const [open, setOpen] = React.useState(false);

  const [isDirty, setIsDirty] = React.useState(false);

  const [dialogOpen, setDialogOpen] = React.useState(false);

  const [failureOpen, setOpenFailure] = React.useState(false);

  const [addedSuccessfullyOpen, setAddedSuccessfullyOpen] = React.useState(false)


  const [flaggedMessage, setFlaggedMessage] = useState(projectDetail.flaggedMessage || 'This job requires attention')

  const [loading, setLoading] = useState(true);
  //  const loading = userProfile.autonumber && !projectId;




  const [modalOpen, setModalOpen] = useState(false);
  const [currentOptionFieldDisplayed, setCurrentOptionFieldDisplayed] = useState({ label: "", name: "" })
  const [userDefinedOption, setUserDefinedOption] = useState('')
  const [editingOption, setEditingOption] = useState(null);
  const [typeFieldOptions, setTypeFieldOptions] = useState([])
  const [akaFieldOptions, setAkaFieldOptions] = useState([])
  const [acpReportFieldOptions, setAcpReportFieldOptions] = useState([])
  const [selfCertificationFieldOptions, setSelfCertificationFieldOptions] = useState([])
  const [reconReqdFieldOptions, setReconReqdFieldOptions] = useState([])






  useFetchUserDefinedOptions(
    ["type", "aka", "ACPReport", "selfCertification", "reconReqd"], // Field names to fetch
    [setTypeFieldOptions, setAkaFieldOptions, setAcpReportFieldOptions, setSelfCertificationFieldOptions, setReconReqdFieldOptions], // Corresponding state setters
    [showAllDataFlag, groupId, userId], // Dependencies
    db,
    groupId,
    showAllDataFlag,
    userId
  );






  useEffect(() => {
    const fetchGroupUsers = async () => {
      if (!groupId) return;

      try {
        const q = query(
          collection(db, 'profiles'),
          where('groupId', '==', groupId)
        );

        const querySnapshot = await getDocs(q);
        const users = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setGroupUsers(users);
      } catch (error) {
        console.error('Error fetching group users:', error);
      }
    };

    fetchGroupUsers();
  }, [groupId]);




  useEffect(() => {
    getBuildingInfo(projectDetail?.building)
  }, [projectDetail])


  const getBuildingInfo = async (buildingId) => {
    if (!buildingId) {
      return;
    }

    try {
      const buildingRef = doc(db, "buildings", buildingId);
      const buildingSnap = await getDoc(buildingRef);

      if (!buildingSnap.exists()) {
        console.warn(`No building found with ID: ${buildingId}`);
        return;
      }

      const buildingData = buildingSnap.data();

      let ownerName = "";

      if (buildingData.owner) {

        const ownerRef = doc(db, "contacts", buildingData.owner);
        const ownerSnap = await getDoc(ownerRef);

        if (ownerSnap.exists()) {
          ownerName = ownerSnap.data().fullName;
        }
      }

      setProjectBuildingDetails({
        ...buildingData,
        owner: ownerName,
      });
    } catch (error) {
      console.error("Error fetching building details:", error);
    }
  };




  // const userProfile = userProfileProfile;

  // console.log("userProfile", userProfile);

  const openSuccess = () => {
    setOpen(true);
  };

  const openFailure = () => {
    setOpenFailure(true);
  };

  const openAddedSuccessfully = () => {
    setAddedSuccessfullyOpen(true);
  };

  const handleCloseAddedSuccessfully = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAddedSuccessfullyOpen(false);
  };




  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleFailureClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailure(false);
  };

  const handleduplicateOpen = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setduplicateOpen(false);
  };

  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };

  const handleDateChange = (fieldName, value) => {
    let currentProjectDetail = projectDetail;
    setIsDirty(true);
    currentProjectDetail[fieldName] = JSON.stringify(value);
    setProjectDetail({ ...currentProjectDetail });
  };

  const saveAndClose = () => {
    onSubmit(projectDetail);
    navigate("/projects");
  };

  const handleChange = (e) => {
    if (e.target.name == "building") {
      getBuildingInfo(e.target.value)
    }
    let currentProjectDetail = projectDetail;
    currentProjectDetail[e.target.name] = e.target.value;
    setIsDirty(true);
    setProjectDetail({ ...currentProjectDetail });
  };

  const discardAndClose = () => {
    navigate("/projects");
  };

  const handleCloseProject = () => {
    if (isDirty) {
      setDialogOpen(true);
      return;
    }

    if (location?.state?.fromBuildingReferencesJobDetails?.fromBuildingReferencesJob) {
      navigate(`/buildings/details/${location?.state?.fromBuildingReferencesJobDetails.buildingId}`, { state: { FromJobDetailsReferencesBuilding: true } });
    } else {
      navigate("/projects");
    }

  };


  const clientDetails = contacts.find(c => projectDetail?.client === c.id);
  const tenantDetails = contacts.find(c => projectDetail?.tenant === c.id);
  const assignedToName = groupUsers.find(u => u.id === projectDetail?.assignedTo)?.name || "";
  const building = buildings.find(b => b.id === projectDetail.building) || {};

  const buildingString_lc = building.customerReference_lc || (building.customerReference || "").trim().toLowerCase();
  const buildingAddress = `${building.houseNumber || ""} ${building.streetName || ""}`.trim();
  const buildingAddress_lc = buildingAddress.toLowerCase();


const onSubmit = async () => {
  setSubmitLoader(true);
  // Get current timestamp in epoch format
  const currentTimestamp = Date.now();

  const projectData = {
    ...projectDetail,
    dateCreated: currentTimestamp, // Changed to epoch
    dateUpdated: currentTimestamp, // Changed to epoch
    customerReference_lc: projectDetail.customerReference.trim().toLowerCase(),
    status_lc: (projectDetail.status || '').trim().toLowerCase(),
    aka_lc: (projectDetail.aka || '').trim().toLowerCase(),
    client_lc: (clientDetails?.businessName || '').trim().toLowerCase(),
    tenant_lc: (tenantDetails?.businessName || '').trim().toLowerCase(),
    applicant_lc: (projectDetail.applicantName || '').trim().toLowerCase(),
    filingRep_lc: (projectDetail.filingRepName || '').trim().toLowerCase(),
    assignedTo_lc: (assignedToName || '').trim().toLowerCase(),
    buildingString_lc,
    buildingAddress_lc,
    flagged: projectDetail.flagged ?? false,
    flaggedMessage: projectDetail.flaggedMessage || "This job requires attention",
    userId: userProfile.uid,
    groupId,
  };
  
  const projectRef = await addDoc(collection(db, "projects"), projectData);

  const newCard = {
    id: projectRef.id,
    title: projectDetail.customerReference,
    description: "",
    details: projectDetail.workDescription || "",
    due: projectDetail.date || "",
    isJobTask: true,
    ...(projectDetail.assignedTo ? { assignedTo: projectDetail.assignedTo } : {}),
  };

  const todosQ = query(collection(db, "todos"), where("groupId", "==", groupId));
  const todosSnap = await getDocs(todosQ);

  if (todosSnap.empty) {
    const seededBoard = {
      columns: [
        { id: 1, title: "Backlog", cards: [newCard] },
        { id: 2, title: "In Progress", cards: [] },
        { id: 3, title: "For Review", cards: [] },
        { id: 4, title: "Completed", cards: [] },
        { id: 5, title: "Archived", cards: [] },
      ],
    };
    await addDoc(collection(db, "todos"), {
      id: uuidv4(),
      groupId,
      userId: userProfile.uid,
      board: seededBoard,
    });
  } else {
    const todoDoc = todosSnap.docs[0];
    const board = todoDoc.data().board;
    board.columns[0].cards.push(newCard);
    await updateDoc(doc(db, "todos", todoDoc.id), { board });
  }

  setSubmitLoader(false);
  openAddedSuccessfully();
  setTimeout(() => {
    navigate(`/projects/details/${projectRef.id}`);
  }, 2000);
};

  const hasRequiredFields = () => {
    return !!projectDetail.customerReference;
  };

  function zeroPad(num, count) {
    var numZeropad = num + "";
    while (numZeropad.length < count) {
      numZeropad = "0" + numZeropad;
    }
    return numZeropad;
  }

  const autoNumberProject = async () => {
    try {
      // Fetch all projects
      const projectsSnapshot = await db.collection("projects").get();
      const projects = projectsSnapshot.docs.map((doc) => doc.data());

      // Extract the format and create a regex from userProfile.projectNumberFormat
      const format = userProfile.projectNumberFormat;

      var base = format.replace(/#/g, "");

      const digits = format.split("#").length - 1;

      // Filter projects that match the format and extract the numerical part
      const matchingNumbers = projects
        .filter((project) => project.customerReference?.indexOf(base) !== -1)
        .map((project) =>
          parseInt(project.customerReference?.replace(base, "")),
        )
        .filter((number) => !isNaN(number));

      // Determine the next number in sequence

      var nextNumber =
        matchingNumbers.length > 0 ? Math.max(...matchingNumbers) + 1 : 1;

      if (digits.length > 0) {
        nextNumber = zeroPad(nextNumber, digits);
      }

      // Format the next number according to userProfile.projectNumberFormat

      const nextCustomerReference = base + nextNumber;

      // Set the nextCustomerReference in the state
      setProjectDetail({
        ...projectDetail,
        customerReference: nextCustomerReference ? nextCustomerReference : "",
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      openFailure();
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (userProfile.autonumber) {
      autoNumberProject();
    } else {
      setLoading(false)
    }


  }, [userProfile.autonumber]);




  const handleFlagCheckboxChange = (event) => {
    setIsDirty(true);
    setProjectDetail((prev) => {
      return { ...prev, flagged: event.target.checked }
    })

  };

  const handleFlaggedTextChange = (event) => {
    setIsDirty(true);
    setFlaggedMessage(event.target.value)
    setProjectDetail((prev) => {
      return { ...prev, flaggedMessage: event.target.value }
    })
  };



  const handleOpenModal = (option = null, currentOptionNameId, currentOptionLabel) => {
    setEditingOption(option);
    setUserDefinedOption(option ? option.value : "");
    setCurrentOptionFieldDisplayed({ name: currentOptionNameId, label: currentOptionLabel })
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setEditingOption(null);
    setUserDefinedOption("");
    setOpenModal(false);
  };



  const handleAddOrEditUserDefinedValue = async (nameId) => {
    if (!userDefinedOption.trim()) return;

    const userProfileRef = db.collection("profiles").doc(userId);

    try {
      if (editingOption) {

        await updateDoc(userProfileRef, {
          userDefinedOptions: arrayRemove(editingOption),
        });

        await updateDoc(userProfileRef, {
          userDefinedOptions: arrayUnion({ name: nameId, value: userDefinedOption }),
        });
      } else {
        await updateDoc(userProfileRef, {
          userDefinedOptions: arrayUnion({ name: nameId, value: userDefinedOption }),
        });
      }

      handleCloseModal();
    } catch (error) {
      console.error("Error saving option: ", error);
    }
  };


  const handleDeleteOption = (optionToDelete, stateSetter, stateData) => {
    if (stateSetter && stateData) {
      stateSetter((prevOptions) =>
        prevOptions.filter((option) => option.value !== optionToDelete.value)
      );
    }

    db.collection("profiles")
      .where("userId", "==", userId)
      .get()
      .then((snapshot) => {
        snapshot.docs.forEach((doc) => {
          const data = doc.data();
          if (data?.userDefinedOptions) {

            const updatedOptions = data.userDefinedOptions.filter(
              (option) =>
                option.name !== optionToDelete.name || option.value !== optionToDelete.value
            );

            db.collection("profiles").doc(doc.id).update({
              userDefinedOptions: updatedOptions,
            });
          }
        });
      })
      .catch((error) => console.error("Error deleting option from Firestore: ", error));

  };



  return (
    <>
      <Modal open={openModal} onClose={handleCloseModal}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            backgroundColor: "white",
            padding: 20,
          }}
        >
          <h2>{editingOption ? "Edit Option" : "Add Option"}</h2>

          <TextField
            label={currentOptionFieldDisplayed.label || ""}
            variant="outlined"
            value={userDefinedOption}
            onChange={(e) => setUserDefinedOption(e.target.value)}
            fullWidth
            required
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() => handleAddOrEditUserDefinedValue(currentOptionFieldDisplayed.name)}
            style={{ marginTop: 20 }}
          >
            {editingOption ? "Save Changes" : "Add Option"}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseModal}
            style={{ marginTop: 20, marginLeft: "1rem" }}
          >
            Cancel
          </Button>
        </div>
      </Modal>




      <Typography
        sx={{ textTransform: "uppercase", marginBottom: "1rem" }}
        align="left"
        variant="h4"
      >
        New JOB
      </Typography>


      <Grid container spacing={2}>


        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={projectDetail.flagged ? projectDetail.flagged : false}
                onChange={handleFlagCheckboxChange}
              />
            }
            label="Flag this Job"
          />
        </Grid>

        {projectDetail.flagged && (
          <Grid item xs={12}>
            <TextField
              label="Flagged Message"
              variant="outlined"
              value={flaggedMessage}
              onChange={handleFlaggedTextChange}
              fullWidth
              InputProps={{
                style: { color: "red" },
              }}

            />
          </Grid>
        )}


        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Job ID"
            variant="outlined"
            name="customerReference"
            value={projectDetail.customerReference || ""}
            onInput={handleChange}
            //  InputLabelProps={{ shrink: true }}

            fullWidth
            required
            InputProps={{
              endAdornment: loading && (
                <CircularProgress size={20} />
              )
            }}
          />
        </Grid>


        <Grid item xs={12} md={6} lg={4}>

          <div style={{ position: "relative" }}>
            <div
              className="addFromAutofillContactSection"
              onClick={() => handleOpenModal(null, "type", "Type")}
            >
              <AddIcon />
            </div>

            <TextField
              select
              label="Type"
              variant="outlined"
              name="type"
              value={projectDetail.type || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: projectDetail.type && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleChange({ target: { name: "type", value: "" } });
                    }}
                    style={{ marginRight: 20 }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            >
              {["New Building (NB)",
                "Big Alt",
                "Alteration Type 1 (Alt 1)",
                "Alteration Type 2 (Alt 2)",
                "Alteration Type 3 (Alt 3)",
                "Place of Assembly (PA)",
                "Sign (SG)",].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              {projectDetail.type &&
                ![
                  "New Building (NB)",
                  "Big Alt",
                  "Alteration Type 1 (Alt 1)",
                  "Alteration Type 2 (Alt 2)",
                  "Alteration Type 3 (Alt 3)",
                  "Place of Assembly (PA)",
                  "Sign (SG)",
                  ...typeFieldOptions.map((option) => option.value)
                ].includes(projectDetail.type) && (
                  <MenuItem key={projectDetail.type} value={projectDetail.type} className="menu-item-options">
                    {projectDetail.type}
                  </MenuItem>
                )}

              {/* {typeFieldOptions?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.value}
        </MenuItem>
      ))} */}
              {typeFieldOptions?.map((option) => (
                <MenuItem key={option.value} value={option.value} className="menu-item-options" >
                  {option.value}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenModal(option, "type", "Type");
                    }}
                    style={{ marginLeft: "auto" }}
                    className="edit-icon-inside-options"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  {option.createdByCurrentUser && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteOption(option, setTypeFieldOptions, typeFieldOptions);
                      }}
                      style={{ marginLeft: 10 }}
                      className="edit-icon-inside-options"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </MenuItem>
              ))}

            </TextField>

          </div>

        </Grid>




        <Grid item xs={12} md={6} lg={4}>

          <div style={{ position: "relative" }}>
            <div
              className="addFromAutofillContactSection"
              onClick={() => handleOpenModal(null, "aka", "AKA")}
            >
              <AddIcon />
            </div>

            <TextField
              select
              label="AKA"
              variant="outlined"
              name="aka"
              value={projectDetail.aka || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: projectDetail.aka && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleChange({ target: { name: "aka", value: "" } });
                    }}
                    style={{ marginRight: 20 }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            >
              {projectDetail.aka &&
                !akaFieldOptions?.map((option) => option.value).includes(projectDetail.aka) && (
                  <MenuItem key={projectDetail.aka} value={projectDetail.aka}>
                    {projectDetail.aka}
                  </MenuItem>
                )}
              {akaFieldOptions?.map((option) => (
                <MenuItem key={option.value} value={option.value} className="menu-item-options" >
                  {option.value}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenModal(option, "aka", "AKA");
                    }}
                    style={{ marginLeft: "auto" }}
                    className="edit-icon-inside-options"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  {option.createdByCurrentUser && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteOption(option, setAkaFieldOptions, akaFieldOptions);
                      }}
                      style={{ marginLeft: 10 }}
                      className="edit-icon-inside-options"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </MenuItem>
              ))}

            </TextField>

          </div>

        </Grid>



        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Status"
            variant="outlined"
            name="status"
            value={projectDetail.status}
            onInput={handleChange}
            fullWidth

          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Date"
            variant="outlined"
            name="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={projectDetail.date}
            onInput={handleChange}
            fullWidth

          />
        </Grid>



        <Grid item xs={12} md={6} lg={4}>
          <TextField
            name="DOBNumber"
            label="DOB reference (BIS or Now!)"
            variant="outlined"
            value={projectDetail.DOBNumber}
            onInput={handleChange}
            fullWidth
          />
        </Grid>



        <Grid item xs={12} md={6} lg={4}>
          {/* <TextField
              label={"Project manager"}
              name="projectManager"
              onChange={handleChange}
              select
              value={projectDetail.projectManager}
              fullWidth
            >
              {contacts.map((contact) => (
                <MenuItem value={contact.id}>{contact.fullName}</MenuItem>
              ))}
            </TextField> */}
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={handleChange}
            value={projectDetail.projectManager}
            name="projectManager"
            inputLabel="Project manager"
          />
        </Grid>



        {currentSubscription?.isPro && (
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Assigned To"
              name="assignedTo"
              select
              onChange={handleChange}
              value={projectDetail.assignedTo || ""}
              fullWidth
              InputProps={{
                endAdornment: projectDetail.assignedTo ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        handleChange({ target: { name: 'assignedTo', value: '' } })
                      }
                      style={{ marginRight: '10px' }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            >
              {groupUsers.length > 0 ? (
                groupUsers.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name} ({user.email})
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No users available</MenuItem>
              )}
            </TextField>
          </Grid>
        )}



      </Grid>





      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Building Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            collectionName="buildings"
            label="customerReference"
            onChange={handleChange}
            value={projectDetail.building}
            name="building"
            inputLabel="Building"
          />
        </Grid>


      </Grid>


      {projectDetail?.building && (
        <>

          <Grid container spacing={3} marginTop={3}>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                Name:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.customerReference || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                Borough:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.borough || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                Owner:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.owner || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                BIN:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.BIN || "N/A"}
              </Typography>
            </Grid>
          </Grid>


          <Typography
            variant="h4"
            sx={{ fontWeight: 'bold', color: "#111715", marginTop: "30px", marginBottom: "20px", fontSize: '1.5rem', paddingLeft: "5px" }}
          >
            Address Details
          </Typography>

          <Grid container spacing={3}>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                House Number:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.houseNumber || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                Street Name:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.streetName || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                Special Place Name:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.specialPlaceName || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                City:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.city || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                State:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.state || "N/A"}
              </Typography>
            </Grid>


            <Grid item xs={12} md={6} lg={4}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'bold', color: '#111715', fontSize: '1rem' }}
              >
                ZIP:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: '1.1rem' }}
              >
                {projectBuildingDetails?.ZIP || "N/A"}
              </Typography>
            </Grid>
          </Grid>

        </>
      )}




      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Job Contacts
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          {/* <TextField
              label={"Client"}
              name="client"
              onChange={handleChange}
              value={projectDetail.client}
              select
              fullWidth
            >
              {contacts.map((contact) => (
                <MenuItem value={contact.id}>{contact.fullName}</MenuItem>
              ))}
            </TextField> */}
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={handleChange}
            value={projectDetail.client}
            name="client"
            inputLabel="Client"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={handleChange}
            value={projectDetail.tenant}
            inputLabel="Tenant"
            name="tenant"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={handleChange}
            value={projectDetail.applicant}
            name="applicant"
            inputLabel="Applicant"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={handleChange}
            value={projectDetail.contractor}
            name="contractor"
            inputLabel="Contractor"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={async (e) => {
              const updated = {
                ...projectDetail,
                filingRep: e.target.value,
                filingRepName: contacts.find(c => c.id === e.target.value)?.fullName || ""
              };
              setIsDirty(true);
              setProjectDetail(updated);
            }}
            value={projectDetail.filingRep || ""}
            name="filingRep"
            inputLabel="Filing representative"
          />
        </Grid>


      </Grid>



      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Additional Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Landmark Status"
            variant="outlined"
            name="landmarkStatus"
            value={projectDetail.landmarkStatus}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Little E"
            variant="outlined"
            name="littleE"
            value={projectDetail.littleE}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Loft Law"
            variant="outlined"
            name="loftLaw"
            value={projectDetail.loftLaw}
            onChange={handleChange}
            fullWidth
          />
        </Grid>


        <Grid item xs={12} md={6} lg={4}>

          <div style={{ position: "relative" }}>
            <div
              className="addFromAutofillContactSection"
              onClick={() => handleOpenModal(null, "ACPReport", "ACP Report")}
            >
              <AddIcon />
            </div>

            <TextField
              select
              label="ACP Report"
              variant="outlined"
              name="ACPReport"
              value={projectDetail.ACPReport || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: projectDetail.ACPReport && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleChange({ target: { name: "ACPReport", value: "" } });
                    }}
                    style={{ marginRight: 20 }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            >
              {[
                "ACP-21",
                "ACP5",
                "ACP5 (by client)",
                "ACP5 by owner",
                "ACP-5 Carmelo",
                "ACP-5 Robert",
                "ASB-4",
                "N/A",
                "Other",
                "Owner"
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}

              {projectDetail.ACPReport &&
                ![
                  "ACP-21",
                  "ACP5",
                  "ACP5 (by client)",
                  "ACP5 by owner",
                  "ACP-5 Carmelo",
                  "ACP-5 Robert",
                  "ASB-4",
                  "N/A",
                  "Other",
                  "Owner",
                  ...acpReportFieldOptions?.map((option) => option.value)
                ].includes(projectDetail.ACPReport) && (
                  <MenuItem key={projectDetail.ACPReport} value={projectDetail.ACPReport} className="menu-item-options">
                    {projectDetail.ACPReport}
                  </MenuItem>
                )}

              {acpReportFieldOptions?.map((option) => (
                <MenuItem key={option.value} value={option.value} className="menu-item-options" >
                  {option.value}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenModal(option, "ACPReport", "ACP Report");
                    }}
                    style={{ marginLeft: "auto" }}
                    className="edit-icon-inside-options"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  {option.createdByCurrentUser && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteOption(option, setAcpReportFieldOptions, acpReportFieldOptions);
                      }}
                      style={{ marginLeft: 10 }}
                      className="edit-icon-inside-options"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}

                </MenuItem>
              ))}

            </TextField>

          </div>

        </Grid>





        <Grid item xs={12} md={6} lg={4}>

          <div style={{ position: "relative" }}>
            <div
              className="addFromAutofillContactSection"
              onClick={() => handleOpenModal(null, "selfCertification", "self Cert")}
            >
              <AddIcon />
            </div>

            <TextField
              select
              label="self Cert"
              variant="outlined"
              name="selfCertification"
              value={projectDetail.selfCertification || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: projectDetail.selfCertification && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleChange({ target: { name: "selfCertification", value: "" } });
                    }}
                    style={{ marginRight: 20 }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            >

              {projectDetail.selfCertification &&
                ![
                  ...selfCertificationFieldOptions?.map((option) => option.value)
                ].includes(projectDetail.selfCertification) && (
                  <MenuItem key={projectDetail.selfCertification} value={projectDetail.selfCertification} className="menu-item-options">
                    {projectDetail.selfCertification}
                  </MenuItem>
                )}

              {selfCertificationFieldOptions?.map((option) => (
                <MenuItem key={option.value} value={option.value} className="menu-item-options" >
                  {option.value}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenModal(option, "selfCertification", "self Cert");
                    }}
                    style={{ marginLeft: "auto" }}
                    className="edit-icon-inside-options"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>


                  {option.createdByCurrentUser && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteOption(option, setSelfCertificationFieldOptions, selfCertificationFieldOptions);
                      }}
                      style={{ marginLeft: 10 }}
                      className="edit-icon-inside-options"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </MenuItem>
              ))}

            </TextField>

          </div>

        </Grid>



        <Grid item xs={12} md={6} lg={4}>

          <div style={{ position: "relative" }}>
            <div
              className="addFromAutofillContactSection"
              onClick={() => handleOpenModal(null, "reconReqd", "Recon Required")}
            >
              <AddIcon />
            </div>

            <TextField
              select
              label="Recon Required"
              variant="outlined"
              name="reconReqd"
              value={projectDetail.reconReqd || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: projectDetail.reconReqd && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleChange({ target: { name: "reconReqd", value: "" } });
                    }}
                    style={{ marginRight: 20 }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            >
              {projectDetail.reconReqd &&
                ![
                  ...reconReqdFieldOptions?.map((option) => option.value)
                ].includes(projectDetail.reconReqd) && (
                  <MenuItem key={projectDetail.reconReqd} value={projectDetail.reconReqd} className="menu-item-options">
                    {projectDetail.reconReqd}
                  </MenuItem>
                )}

              {reconReqdFieldOptions?.map((option) => (
                <MenuItem key={option.value} value={option.value} className="menu-item-options" >
                  {option.value}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenModal(option, "reconReqd", "Recon Required");
                    }}
                    style={{ marginLeft: "auto" }}
                    className="edit-icon-inside-options"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  {option.createdByCurrentUser && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteOption(option, setReconReqdFieldOptions, reconReqdFieldOptions);
                      }}
                      style={{ marginLeft: 10 }}
                      className="edit-icon-inside-options"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}



                </MenuItem>
              ))}

            </TextField>

          </div>

        </Grid>



        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Proposal Sent"
            variant="outlined"
            name="proposalSent"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={projectDetail.proposalSent}
            onInput={handleChange}
            fullWidth

          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Proposal Received"
            variant="outlined"
            name="proposalRecd"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={projectDetail.proposalRecd}
            onInput={handleChange}
            fullWidth

          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Floor(s)"
            variant="outlined"
            name="floors"
            value={projectDetail.floors}
            onChange={handleChange}
            fullWidth

          />
        </Grid>


        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Apt./Condo No(s)"
            variant="outlined"
            name="apt"
            value={projectDetail.apt}
            onChange={handleChange}
            fullWidth

          />
        </Grid>


        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Tracking Number"
            variant="outlined"
            name="trackingNumber"
            value={projectDetail.trackingNumber}
            onChange={handleChange}
            fullWidth

          />
        </Grid>

        <Grid item xs={12} md={12} lg={6}>
          <TextField
            label="Work Description"
            variant="outlined"
            multiline
            rows="6"
            name="workDescription"
            value={projectDetail.workDescription}
            onInput={handleChange}
            fullWidth
          />
        </Grid>


      </Grid>


      <SaveCloseDialog
        open={dialogOpen}
        saveAndClose={saveAndClose}
        discardAndClose={discardAndClose}
        setDialogOpen={setDialogOpen}
        isInactive={props.isInactive}
      />

      <Box
        sx={{
          position: "fixed",
          bottom: "1rem",
          right: "1rem",
          "& > :not(style)": { m: 1 },
        }}
      >
        {!props.isInactive && (
          <Fab
            color="primary"
            aria-label="add"
            variant="extended"
            onClick={onSubmit}
            form="contactForm"
            disabled={(SubmitLoader || !isDirty && !hasRequiredFields()) || props.isInactive}
          >
            <Save sx={{ mr: 1 }} />
            {/* Save */}
            Add
          </Fab>
        )}
        <Fab
          color="secondary"
          aria-label="add"
          variant="extended"
          onClick={handleCloseProject}
        >
          <Close sx={{ mr: 1 }} />
          {/* Close */}
          Cancel
        </Fab>
      </Box>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Contact successfully saved!
        </Alert>
      </Snackbar>
      <Snackbar
        open={failureOpen}
        autoHideDuration={2000}
        onClose={handleFailureClose}
      >
        <Alert
          onClose={handleFailureClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          Something went wrong!
        </Alert>
      </Snackbar>

      <Snackbar
        open={duplicateOpen}
        autoHideDuration={2000}
        onClose={handleduplicateOpen}
      >
        <Alert
          onClose={handleduplicateOpen}
          severity="error"
          sx={{ width: "100%" }}
        >
          Job ID already exists!
        </Alert>
      </Snackbar>
      <Snackbar
        open={addedSuccessfullyOpen}
        autoHideDuration={2000}
        onClose={handleCloseAddedSuccessfully}
      >
        <Alert
          onClose={handleCloseAddedSuccessfully}
          severity="success"
          sx={{ width: "100%" }}
        >
          Project added successfully!
        </Alert>
      </Snackbar>


    </>
  );
};
